import axios from "axios"
import {Toast} from "vant";
import router from "../router/index"
export default {
    data() {
        return {

        }
    },
    created: function () {

    },
    mounted: function () {

    },
    methods: {
        fetchData: (url, queryData, callback) => {
            axios
                .get(url, {params:queryData})
                .then(response => {
                    callback(response)
                })
                .catch(err => {
                    Element.Message.error('获取失败，请刷新页面');
                })
        },
        fetchDataPost: function (url ,post ,callback) {
            axios
                .post(url, post)
                .then(response => {
                    callback(response)
                })
                .catch(err => {
                    Element.Message.error('获取失败，请刷新页面');
                })
        },
        upload(url,file,data,callback){
            let fileData = new FormData();
            //fileData.append('file[]',file)
            for(let i in file){
                fileData.append('file[]',file[i],file[i].name)
            }

           /* fileData.append('file',file[0])
            fileData.append('file',file[1])*/
            for(let i in data){
                fileData.append(i,data[i]);
            }
            const config = {
                headers: { "Content-Type": "multipart/form-data" }
            };
            axios.defaults.transformRequest = function (data) {
                return data;
            }
            axios.post(url, fileData,config)
                .then(response => {
                    callback(response)
                })
                .catch(err => {
                    Toast.clear()
                    Toast.fail('system error post');
                })
        },
        onClickLeft(){
            router.go(-1)
        },
        goHome(){
            router.push({name:'home'})
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/do_request.js